// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__741Eo","inner":"Footer_inner__2Jgmv","nextIcon":"Footer_nextIcon__SijPj","innerLeft":"Footer_innerLeft__1vYXX"};